<div class="flex flex-col">
  <label for="pbu-inline-selector" class="sr-only">Business Unit</label>
  <select id="pbu-inline-selector"
    class="min-w-[150px] max-w-[200px] h-7 px-2 py-1 rounded border border-gray-500 bg-gray-600 text-white text-xs focus:outline-white focus:outline-2 hover:bg-gray-500 cursor-pointer"
    [(ngModel)]="selectedId" (ngModelChange)="onModelChange($event)" [attr.aria-label]="'Select Business Unit'">
    @for (unit of businessUnits; track $index) {
    <option class="bg-gray-700 text-white" [ngValue]="unit.business_unit.id">{{ unit.business_unit.name }} - ({{
      unit.role.name }})</option>
    }
  </select>
</div>
